export default __webpack_public_path__ + "static/media/p1-10.5d23a03f.png";